export default __webpack_public_path__ + "static/media/doughnut.f6ed7473.png";